export type YesNoOption = 'yes' | 'no';
